import { cookiesStore } from './store';
import { StorageManager } from '@vue-storefront/core/lib/storage-manager';
import { StorefrontModule } from '@vue-storefront/core/lib/modules';

export const CookiesModule: StorefrontModule = function ({ store }) {
  StorageManager.init('cookies');
  store.registerModule('cookies', cookiesStore);
};
